import tree from '../state';
import * as faqService from '../services/faqService';
import * as contactUsService from '../services/contactUsService';
import * as productService from '../services/productService';
import * as supportService from '../services/supportService';

export const enterSupportAction = ({ params }, replace, callback) => {
    tree.set('loading', true);
    
    faqService.getfaqs().then(category => {
        tree.set('category', category);
        tree.set('loading', false);
        callback();
    });
};

export const enterContactUsAction = () => {
    tree.set('loading', true);
    contactUsService.getContactUs().then(contact => {
        tree.set('support', contact);
        tree.set('loading', false);
    });
};

export const enterProductManualAction = ({ params }, replace, callback) => {
    tree.set('loading', true);
    productService.getProductsSearch(params.sku).then(product => {
        tree.set('product', product);
        tree.set('loading', false);
        callback();
    });
};

export const getLostKeyComboAction = ({ params }, replace, callback) => {
	tree.set('loading', true);
	supportService.getLostKeyComboModel(params.country).then(model => {
		tree.set('model', model);
        tree.set('loading', false);
        callback();
	});
};



// WEBPACK FOOTER //
// ./src/actions/supportActions.js